export type Difficulty = 'beginner' | 'intermediate' | 'advanced' | 'expert' | 'guru' | 'custom';

export interface QuizQuestion {
  question: string;
  options: string[];
  correct: number;
  explanation: string;
  links?: { title: string; url: string }[];
}

export interface QuizState {
  difficulty: Difficulty;
  questionCount: number;
  questions: QuizQuestion[];
  currentIndex: number;
  score: number;
  selectedAnswer: number | null;
  userAnswers: (number | null)[];
  isCompleted: boolean;
  isLoading: boolean;
  userTopic?: string;
}

export interface LessonCategory {
  icon: string;
  title: string;
  sub: string;
}

export interface LessonContent {
  title: string;
  summary: string;
  sections: {
    heading: string;
    content: string;
  }[];
  keyTakeaways: string[];
  imageUrl?: string;
  links?: { title: string; url: string }[];
}

export enum AppScreen {
  AUTH,
  START,
  TOPIC_SELECTION,
  COUNT_SELECTION,
  QUIZ,
  RESULTS,
  LESSONS,
  LESSON_VIEW,
  NEWS,
  PROMPTING,
  LIBRARY,
  SCENARIOS,
  HOME,
  LEARN,
  PRACTICE,
  CREW,
}

export type ShellTab = 'home' | 'learn' | 'practice' | 'crew' | 'news';

export interface ScenarioBranch {
  id: string;
  label: string;
  outcome: string;
}

export interface BridgeScenario {
  id: string;
  title: string;
  situation: string;
  category: string;
  difficulty: string;
  branches: ScenarioBranch[];
  ideal_prompt_traits: string[];
  badge_unlock: string | null;
}

export interface ScenarioGradeResult {
  score: number;
  passed: boolean;
  feedback: string;
  strengths: string[];
  improvements: string[];
  outcome: string;
  branch_label: string;
}

export const PROMPT_CATEGORIES = [
  { id: 'general', label: 'General' },
  { id: 'cargo_ops', label: 'Cargo Ops' },
  { id: 'weather_routing', label: 'Weather Routing' },
  { id: 'port_docs', label: 'Port Documentation' },
  { id: 'marpol', label: 'MARPOL Compliance' },
  { id: 'crew_management', label: 'Crew Management' },
  { id: 'voyage_planning', label: 'Voyage Planning' },
] as const;

export type PromptCategory = typeof PROMPT_CATEGORIES[number]['id'];

export interface SavedPrompt {
  id: string;
  user_id: string;
  title: string;
  prompt_text: string;
  ai_output: string | null;
  category: string;
  tags: string[];
  is_public: boolean;
  rating_avg: number;
  rating_count: number;
  created_at: string;
  updated_at: string;
}

export interface NewsArticle {
  title: string;
  company: string;
  summary: string;
  shippingRelevance: string;
  url: string;
  date?: string;
  category: 'bigtech' | 'maritime' | 'robots';
}

export type UserRole = 'admin' | 'user';

export interface User {
  id: string;
  name: string;
  email: string;
  role: UserRole;
  joinedAt: string;
}
